import React from 'react';
import AutocompleteBase, { AutocompleteBaseProps } from './AutocompleteBase';
import FormikAutocomplete from './FormikAutocomplete';

export interface AutocompleteProps<
  T,
  Multiple extends boolean | undefined = false,
  DisableClearable extends boolean | undefined = false,
  FreeSolo extends boolean | undefined = false,
> extends AutocompleteBaseProps<T, Multiple, DisableClearable, FreeSolo> {
  withFormik?: boolean;
  disableDefaultFormikSetValue?: boolean;
}

const Autocomplete = <
  T,
  Multiple extends boolean | undefined = false,
  DisableClearable extends boolean | undefined = false,
  FreeSolo extends boolean | undefined = false,
>({ withFormik, disableDefaultFormikSetValue, ...props }: AutocompleteProps<T, Multiple, DisableClearable, FreeSolo>) => {

  if (withFormik) {
    return <FormikAutocomplete
      {...props}
      disableDefaultFormikSetValue={disableDefaultFormikSetValue} />;
  }

  return (
    <AutocompleteBase {...props} />
  );
};

export default Autocomplete;